import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { ArticleForm } from "@/components/admin/ArticleForm";

export const Route = createFileRoute("/_authenticated/admin/blog/nuevo")({
  head: () => ({ meta: [{ title: "Nuevo artículo — Admin" }] }),
  component: NewArticle,
});

function NewArticle() {
  return (
    <div>
      <Link
        to="/admin/blog"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" /> Volver al blog
      </Link>
      <h1 className="mt-3 text-2xl font-semibold text-foreground">Nuevo artículo</h1>
      <div className="mt-6">
        <ArticleForm />
      </div>
    </div>
  );
}
